module.exports = __webpack_public_path__ + "img/box7-1.14a87bc6.png";